import { Form } from 'factorial-form'

class AddressForm extends Form {
  constructor(values: Record<string, string> = {}) {
    super(values, {
      address_line_1: 'string',
      address_line_2: 'string',
      city: 'string',
      country: 'string',
      postal_code: 'string',
      state: 'string',
    })
  }
}

export default AddressForm
